import { render, staticRenderFns } from "./PushPartnerTariffs.vue?vue&type=template&id=c23f1b6e&"
import script from "./PushPartnerTariffs.vue?vue&type=script&lang=ts&"
export * from "./PushPartnerTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports